/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-unused-expressions */

function handleInitialAdjustments({ questionnaire, idProduct }) {
  return questionnaire.map(question => {
    if (question.idQuestion === 1941) {
      if (idProduct === 16) {
        question.answerOptions = question.answerOptions.map(v => ({ ...v, behaviorObject: { isRequired: true } }))
      }
    }

    if ([3108, 3109].includes(question.idQuestion)) {
      question.visibleQuestion = false;
    }
    return question;
  })
};

async function handleQuestionChange({
  question,
  value,
  questionnaireUpdated,
  setQuestionnaire,
  setFieldValue,
  questionnaireAnswersToDelete,
  setQuestionnaireAnswersToDelete,
  documentsToDelete,
  setDocumentsToDelete
}) {
  try {
    let saveQuestionnaire = false;

    const newQuestionnaireAnswersToDelete = []
    const newDocumentsToDelete = []

    if (question.idQuestion === 1941) {
      saveQuestionnaire = true;

      if (!Array.isArray(value)) {
        const attachment = question?.answer?.length ? question?.answer[0] : null;
        if (attachment) {
          newDocumentsToDelete.push(attachment.documentId)
        }
      }

      questionnaireUpdated = questionnaireUpdated.map((qst) => {
        if (qst.key === question.key) {
          qst.hiddenInput = value.length;
          qst.answer = qst.answerJson = value?.length ? value : []
          setFieldValue(qst.key, value?.length ? value : [])
        }
        return qst;
      })
    }

    if (newQuestionnaireAnswersToDelete.length) {
      setQuestionnaireAnswersToDelete([
        ...questionnaireAnswersToDelete,
        ...newQuestionnaireAnswersToDelete
          .filter((idQuestionnaireAnswers) => idQuestionnaireAnswers)
          .filter((idQuestionnaireAnswers) => !questionnaireAnswersToDelete.includes(idQuestionnaireAnswers))
      ]);
    }

    if (newDocumentsToDelete.length) {
      setDocumentsToDelete([
        ...documentsToDelete,
        ...newDocumentsToDelete
          .filter((documentId) => !documentsToDelete.includes(documentId))
      ]);
    }

    if (saveQuestionnaire) setQuestionnaire(questionnaireUpdated)
  } catch (e) {
    console.log('POLICY_WORDING - handleQuestionChange - error', e);
  }
}

const events = {
  handleInitialAdjustments,
  handleQuestionChange,
};

export { events };